import React from 'react';

import {
	store,
	setRootModuleData,
	getRootModulePath,
	Modals,
	Module,
	styled,
	getQueryString,
	FlexBox,
	FlexBoxBlock,
	createModelForState,
} from 'ps-gui';
import PageHeader from './blocks/pageheader';
import PageFooter from './blocks/pagefooter';
import { getPhrase } from './data/phrases';
import {
	GlobalContextModel,
	GlobalContext
} from './data/globalcontext';
import LoginModel from './modules/login/loginmodel';
import ActivationModel from './modules/activation/activationmodel';
import BankIdButton from './components/bankidbutton';
import EmailAddress from './components/emailaddress';
import PhoneNumber from './components/phonenumber';
import { pushState } from './data/history';

const Wrapper = styled.div`
	min-width: 1200px;
	iframe.portalVideo {
		width: 40vw;
		height: 50vh;
	}
`;

const Content = styled.div`
	z-index: 0;
	position: relative;
`;

const ContactBlock = styled.div`
	display: inline-block;
	> a {
		display: table;
		margin-bottom: 8px;
	}
`;


export default class PortalRoot extends React.PureComponent {
	constructor() {
		super();
		this.rootModulePath = getRootModulePath();
		this.state = {
			rootModuleState: store.getState().getIn(this.rootModulePath),
			modals: store.getState().get('modal'),
			globalContext: new GlobalContextModel(store.getState())
		};
		this.unsubscribe = store.subscribe(this.storeListener.bind(this));
		this.performerSignIn = this.performerSignIn.bind(this);
		this.producerSignIn = this.producerSignIn.bind(this);
		this.onLoginFormRequested = this.onLoginFormRequested.bind(this);
		const pwt = getQueryString('pwt');
		const li = getQueryString('li') || getQueryString('bmi');
		if (li) {
			this.state.adhocModelState = new LoginModel().setBankIdMatcherInfo(getQueryString('bmi'), getQueryString('bmt'), getQueryString('errc')).getState();
		} else if (pwt) {
			this.state.adhocModelState = new ActivationModel().setToken(pwt).getState();
		}
		this.onPopState = this.onPopState.bind(this);
		//window.removeEventListener('popstate', this.onPopState);
		window.addEventListener('popstate', this.onPopState);
	}

	setSelectedModuleId(moduleId) {
		// rootmodule (model) musi implementovat setSelectedModuleId
		let rootModel = createModelForState(this.state.rootModuleState);
		rootModel = rootModel.setSelectedModuleId(moduleId);
		setRootModuleData(rootModel.getData());
	}

	onPopState(e) {
		const state = e.state;
		console.log('state = ', state);
		if (typeof state === 'string') {
			if (state === 'home') {
				this.setState({
					adhocModelState: null
				});
			} else if (state === 'loginForm') {
				this.showLoginForm();
			} else {
				console.log(state);
				this.setSelectedModuleId(state);
			}
		}
	}

	performerSignIn() {
		window.location = 'https://umelci.intergram.cz/user/login';
	}

	producerSignIn() {
		window.location = 'https://vyrobci.intergram.cz/user/login';
	}

	storeListener() {
		const state = store.getState();
		this.setState({
			rootModuleState: state.getIn(this.rootModulePath),
			modals: state.get('modal'),
			globalContext: this.state.globalContext.fromAppState(state)
		});
	}

	showLoginForm() {
		this.setState({
			adhocModelState: new LoginModel().getState()
		});
	}

	onLoginFormRequested() {
		pushState('loginForm');
		this.showLoginForm();
	}


	componentWillUnmount() {
		this.unsubscribe();
	}

	renderLoggedOut(hasBeenLoggedIn) {
		return (
			<WelcomeMessage>
				<FlexBox>
					<FlexBoxBlock>
						<h1>{getPhrase('welcomeHeader')}</h1>
						<div className="primaryText">{getPhrase('contractNeededForAccess')}</div>
						<h2>{getPhrase('iHaveAContract')}</h2>
						<div className="block">
							<a className="header" onClick={e => {
								e.preventDefault();
								this.onLoginFormRequested();
							}}>{getPhrase('loginWithUserNameAndPassword')}</a>
							<div className="text">{getPhrase('iAmARegisteredUser')}</div>
						</div>
						<BankIdButton margin="32px 0px"/>
						<h2>{getPhrase('iDontHaveAContract')}</h2>
						<div className="block">
							<a className="header" href="https://www.intergram.cz/pro-nositele-prav/" target="_blank" rel="noreferrer">{getPhrase('newContract')}</a>
							<div className="text">{getPhrase('iWantAContract')}</div>
						</div>
						<div className="footer">
							<span className="needAdvice">{getPhrase('needAdvice')}</span>
							<ContactBlock>
								<EmailAddress light preset="intergram" margin="2px 24px 2px 0px"/>
								<PhoneNumber bigIcon light preset="intergram" withHours/>
							</ContactBlock>
						</div>
					</FlexBoxBlock>
					<FlexBoxBlock justifyContent="center" flexGrow="1">
						<div className='rightCol'>
							<h2>{getPhrase('aboutPortal')}</h2>
							<iframe title="Portal" className="portalVideo" src="https://www.youtube.com/embed/DF5RtovcPm8">
							</iframe>
						</div>
					</FlexBoxBlock>
				</FlexBox>
			</WelcomeMessage>
		);
	}

	renderAdhocModule() {
		return (
			<Module
				appState={this.state.adhocModelState}
				onDataChange={data => {
					if (this.state.adhocModelState) {
						if (data) {
							this.setState({
								adhocModelState: this.state.adhocModelState.set('data', data)
							});
						} else {
							this.setState({
								adhocModelState: null
							});
						}
					}
					setRootModuleData(data);
				}}
			/>
		);
	}

	render() {
		//console.log('rms = ', this.state.rootModuleState.toJS());
		const globalContext = this.state.globalContext;

		return (
			<Wrapper key={globalContext.getLanguageId()}>
				<GlobalContext.Provider value={globalContext}>
					<Content>
						<PageHeader
							onLoginFormRequested={this.onLoginFormRequested}
						/>
						{
							this.state.adhocModelState ? this.renderAdhocModule() :
								globalContext.isLoggedIn() ?
									<Module
										appState={this.state.rootModuleState}
										onDataChange={data => {
											//console.log('setData', data.toJS());
											setRootModuleData(data);
										}}
									/>
									:
									globalContext.isLoggedOut() ? this.renderLoggedOut(globalContext.hasBeenLoggedIn()) : null
						}
						<PageFooter />
					</Content>
				</GlobalContext.Provider>
				<Modals
					data={this.state.modals}
				/>
			</Wrapper>
		);
	}
}

const WelcomeMessage = styled.div`
	color: ${props => props.theme.disabledTextColor};

	${props => props.theme.pageContentPadding}

	.primaryText {
		font-weight: 400;
		font-size: 16px;
	}

	.footer {
		border-top: 1px solid ${props => props.theme.pageSeparatorColor};
		padding-top: 24px;
		margin-top: 24px;

		.needAdvice {
			display: inline-block;
			margin-top: 2px;
			margin-right: 24px;
			vertical-align: top;
		}
	}

	.block {
		padding: 12px;
		max-width: 570px;
		background: #FFFFFF;
		font-weight: 500;
		box-shadow: 7px 13px 80px rgba(21, 46, 67, 0.1);
		border-radius: 15px;
		margin-bottom: 16px;

		a.header {
			color: ${props => props.theme.textColor};
			line-height: 32px;
			text-decoration: none;
			cursor: pointer;
			&:hover {
				text-decoration: underline;
			}
			font-size: 18px;
		}

		.text {
			font-size: 14px;
		}
	}

	.rightCol {
		display: table;
		margin: 48px auto;
	}
`;
